module.exports = __webpack_public_path__ + "static/media/error.5eb09549.svg";